export default __webpack_public_path__ + "static/media/DRIVERLICENSEDOCTORCERTIFICATE_BLANK.b7ce6b0c.png";